import React, { FC, useEffect, useState } from 'react';
import config from 'config';
import { Button, Input, Modal, Alert } from 'components/layout';

import './activated-user-modal.scss';

interface Props {
    status?: boolean;
    visible?: boolean;
    loading?: boolean;
    onOk?: Function;
    onCancel?: Function;
}

const ActivatedUserModal: FC<Props> = (props: Props) => {
    const { visible, loading, onOk, onCancel, status } = props;
    const [reasonValue, setReasonValue] = useState<string>(
        status ? config.radio.deactivated[0].value : config.radio.activated[0].value
    );
    const [reason, setReason] = useState<string>('');
    const [comment, setComment] = useState<string>('');
    const [validComment, setValidComment] = useState<boolean>(false);

    const checkComment = (value?: string) => {
        if (reasonValue === 'other' && !value) {
            setValidComment(true);
        } else {
            setValidComment(false);
        }
    };

    const focus = () => {
        setValidComment(false);
    };

    const handlerOk = () => {
        if (reasonValue === 'other') {
            if (onOk && comment) {
                onOk(comment);
            } else if (!comment) {
                setValidComment(true);
            }
        } else if (onOk && reason) {
            onOk(reason);
        }
    };

    const handlerCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };

    const change = (text: string, srcKey: string) => {
        if (srcKey === 'comment') {
            setComment(text);
        } else {
            setReasonValue(text);
        }
    };

    useEffect(() => {
        const reasonArr = status ? config.radio.deactivated : config.radio.activated;
        reasonArr.forEach((item) => {
            if (item.value === reasonValue) {
                setReason(item.label);
            }
        });
    }, [reasonValue]);

    return (
        <Modal
            title={status ? 'Выберите причину деактивации' : 'Выберите причину активации'}
            visible={visible}
            onCancel={handlerCancel}
            footer={[
                <Button key="cancel" type="default" onClick={handlerCancel}>
                    Отмена
                </Button>,
                <Button
                    key="ok"
                    onClick={handlerOk}
                    type="primary"
                    danger={status}
                    loading={loading}
                >
                    {status ? 'Деактивировать пользователя' : 'Активировать пользователя'}
                </Button>,
            ]}
        >
            {!status && (
                <Alert
                    className="activated-user-alert"
                    type="warning"
                    message="Внимание: после активации пользователь получит доступ в систему!"
                />
            )}
            <Input
                type="radio"
                value={reasonValue}
                onChange={change}
                radioOptions={status ? config.radio.deactivated : config.radio.activated}
            />
            <Input
                type="textarea"
                srcKey="comment"
                placeholder={
                    status
                        ? 'Опишите причину деактивации подробнее'
                        : 'Опишите причину активации подробнее'
                }
                value={comment}
                onChange={change}
                maxLength={250}
                onBlur={checkComment}
                onFocus={focus}
                error={reasonValue === 'other' ? validComment : false}
            />
        </Modal>
    );
};

export default ActivatedUserModal;
